/* global hUrl */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

import setCookie from './functions/_cookie-setCookie-server.js' // Cookie発行（サーバーサイド）

import './_top'
import './_youtube'
import './_10story'
import './_enjoy'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
scrollValToggle('#hogeID', 500, false,'active')
 */
scrollValToggle('#header', 1, false, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}
/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスをアクティブにし、他のグループを非アクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>

*/
if (document.getElementsByClassName('js-clickExclActive')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickExclActive')) {
      return
    }
    const group = e.target.dataset.exclGroup
    const target = e.target.dataset.exclTarget
    exclActive(group, target, 'active')
  })
}
function exclActive(group, target, className = 'active') {
  const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove(className)
  }
  const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add(className)
  }
}

/*
    ########  ########   #######  ########  ##     ##  ######  ########
    ##     ## ##     ## ##     ## ##     ## ##     ## ##          ##
    ########  ########  ##     ## ##     ## ##     ## ##          ##
    ##        ##   ##   ##     ## ##     ## ##     ## ##          ##
    ##        ##     ##  #######  ########   #######   ######     ##
*/
// 製品グループ
$('.js-productNav').on('click', function () {
  if (!$(this).hasClass('active')) {
    $(this).parent().siblings().children('.js-productNav').removeClass('active')
    $(this).addClass('active')
    const target = $(this).attr('data-target')
    $(target).siblings('.js-productItem').removeClass('active')
    $(target).addClass('active')
  }
  return false
})

// アクセス時のハッシュで初期タブを変動させる
if (~location.pathname.indexOf('/products/page') && location.hash) {
  const target = location.hash.replace('#', '')
  exclActive('product', target, 'active')
}

// サイズバリエーション
$('.js-productItemAcc').on('click', function () {
  $(this).parent().toggleClass('active')
  $(this).next().slideToggle()
})

//   ####  ##      ##  ####    #####
//  ##     ##      ##  ##  ##  ##
//   ###   ##      ##  ##  ##  #####
//     ##  ##      ##  ##  ##  ##
//  ####   ######  ##  ####    #####

//            ######    ###     ####
//              ##     ## ##   ##
//  ########    ##    ##   ##  ##  ###
//              ##    #######  ##   ##
//              ##    ##   ##   ####

if (document.getElementById('tagSlide')) {
  const slideItem = document.getElementById('tagSlide')
  const sliderName = 'tagSlide'
  const tagSlideSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 300, // アニメ速度
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: 10, //スライド同士の間隔を空ける
    freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
    grabCursor: true, // 掴みカーソル
  })
}

//            ##      ##  #####  #####  ##  ##
//            ##      ##  ##     ##     ## ##
//  ########  ##  ##  ##  #####  #####  ####
//            ##  ##  ##  ##     ##     ## ##
//             ###  ###   #####  #####  ##  ##
if (document.getElementById('recWeek')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('recWeek')
  const sliderName = 'recWeek'
  const recWeekSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（recWeekSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1.2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: 25, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
      renderBullet: function (index, className) {
        // bulletsの描画内容を改変
        const targetText = document.querySelector('#recWeek [data-swiper-slide-index="' + index + '"]').dataset
          .slideName
        return '<div class="' + className + ' flex vcenter hcenter">' + targetText + '</div>'
      },
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      769: {
        slidesPerView: 2.8, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        spaceBetween: 60, //スライド同士の間隔を空ける
      },
    },
    on: {
      init: function () {
        const weekMovie = document.getElementsByClassName('js-weekMovie')
        for (let index = 0; index < weekMovie.length; index++) {
          const element = weekMovie[index]
          element.querySelector('.js-youtube').id = 'slideMovie-' + index
          element.querySelector('.js-youtube-btn').dataset.id = 'slideMovie-' + index
        }
      },
    },
  })
}

//   ####  #####    ###    #####     ####  ##   ##
//  ##     ##      ## ##   ##  ##   ##     ##   ##
//   ###   #####  ##   ##  #####    ##     #######
//     ##  ##     #######  ##  ##   ##     ##   ##
//  ####   #####  ##   ##  ##   ##   ####  ##   ##
// ヘッダーの検索ボタン
const searchOpen = document.querySelectorAll('.js-headerSearch')
const spSearch = document.getElementById('headerSearch')
const spMenuBtn = document.getElementById('gNav-open')
const spMenu = document.getElementById('gNav')
const overlay = document.getElementById('overlay')

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-headerSearch')) {
    return
  }
  if (e.target.classList.contains('active')) {
    spSearchClose()
  } else {
    spSearchOpen()
  }
})
overlay.addEventListener('click', function (e) {
  spSearchClose()
})
spMenuBtn.addEventListener('click', function (e) {
  spSearchClose(false)
})

function spSearchOpen(overlaySwitch = true) {
  itemsClass(searchOpen, 'active', true)
  spSearch.classList.add('active')
  spMenuBtn.classList.remove('active')
  spMenu.classList.remove('active')
  overlay.classList.remove('active')
  scrollLock('body', '#overlay')
  // if (overlaySwitch) {
  //   overlay.classList.add('active')
  //   scrollLock('body', '#overlay')
  // }
}
function spSearchClose(overlaySwitch = true) {
  itemsClass(searchOpen, 'active', false)
  spSearch.classList.remove('active')
  // if (overlaySwitch) {
  //   overlaySwitch.classList.remove('active')
  //   scrollLock('body', '#overlay')
  // }
}

// DOM配列のクラス制御
function itemsClass(itemList, className, toggle = true) {
  if (toggle) {
    for (const item of itemList) {
      item.classList.add(className)
    }
  } else {
    for (const item of itemList) {
      item.classList.remove(className)
    }
  }
}

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

//   ####   #####    #####   ##  ##  ##  #####
//  ##     ##   ##  ##   ##  ## ##   ##  ##
//  ##     ##   ##  ##   ##  ####    ##  #####
//  ##     ##   ##  ##   ##  ## ##   ##  ##
//   ####   #####    #####   ##  ##  ##  #####
// Cookie同意ボックス
if (document.getElementById('cookieBox')) {
  document.getElementById('cookieBox-btn').addEventListener('click', function (e) {
    // ボックスを消す
    document.getElementById('cookieBox').classList.remove('active')
    document.getElementById('cookieBox-pad').classList.remove('active')

    setCookie('btnFlg', 'on', hUrl + 'cookie/', 60 * 60 * 24 * 720) // Cookie発行
  })
}
